<template>
  <div class="modal-content">
    <audio id="player_cfa" preload="none">
      <source src="http://class.pzacademy.com/mp3/cfa.mp3" />
    </audio>
    <audio id="player_frm" preload="none">
      <source src="http://class.pzacademy.com/mp3/frm.mp3" />
    </audio>
    <audio id="player_background" preload="none" loop>
      <source src="http://class.pzacademy.com/mp3/background.mp3" />
    </audio>
    <div
      class="modal-header bg-light justify-content-between align-items-center px-2 py-1"
      v-if="exerciseType == 13 || exerciseType == 12"
    >
      <div class="flex-grow-1 w-0 text-truncate">
        <ul class="list-inline mb-0 d-flex align-items-center text-truncate">
          <li class="list-inline-item mx-0 pr-2 border-right">
            <button type="button" class="btn btn-light text-secondary d-flex" @click="onClose">
              <i class="pz-icon icon-cancel mr-1"></i>
              <span class="d-none d-md-inline-block">关闭</span>
            </button>
          </li>
          <li class="list-inline-item ml-3 text-truncate">
            <h5 class="modal-title text-truncate f-xs-14">{{ title }}</h5>
          </li>
        </ul>
      </div>

      <!-- <h5 class="modal-title text-center text-truncate">{{ title }}</h5> -->

      <ul class="list-inline mb-0">
        <li class="list-inline-item mx-0 mx-lg-2">
          <button
            type="button"
            class="btn btn-light text-secondary d-flex flex-column"
            @click="onResizeModal"
          >
            <i
              class="pz-icon"
              :class="`${isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'}`"
            ></i>
            <small class="d-none d-md-inline-block">全屏</small>
          </button>
        </li>
      </ul>
    </div>
    <div class="modal-body bg-dark p-0" v-if="exerciseType == 13">
      <div
        v-if="!showAudioLayer"
        class="text-white h-full d-flex flex-column justify-content-start align-items-center"
      >
        <div class="w-50 my-5">
          <div class="overflow-hidden text-center mb-5" style="height: 150px">
            <!-- <img src="/img/StartOfTask.eb868f6f.svg" /> -->
            <img src="https://resources.pzacademy.com/image/class-ui/StartOfTask.svg" />
          </div>
          <h1 class="text-center mb-3">考试说明</h1>
          <template v-if="BeforeData.examType != 3">
            <p class="text-secondary">
              开始答题后会有一段考场规则音频，若在图书馆作答，请自备耳机。本模考录音为品职教育整理录制版本，根据协会规则尽可能模拟真实考试场景，提醒考生注意各项考试规则。但跟真实考场仍有出入，请各考生最终以{{
                BeforeData.examType == 1 ? 'CFA' : 'FRM&reg;'
              }}真正考试考官宣读的考试规则为准。
            </p>
            <p class="text-secondary">
              本全真模拟考试只有一次参与机会，点击“开始答题”即开始计时。无补考、重考机会，请确保有足够时间作答再参加。
            </p>
          </template>
          <p v-else class="text-secondary">
            本模拟考试只有一次参与机会，点击“开始答题“即开始计时。无补考、重考机会，请确保有足够时间作答再参加。
          </p>
          <p class="text-primary">
            考前准备：计算器、笔、草稿纸（真实考试草稿纸不可携带，由于答题需要可以向监考人员申请草稿纸）
          </p>
          <p class="text-primary">祝你好运！</p>
        </div>
      </div>
      <div class="bg-light h-100 w-100 pt-3 overflow-auto" v-else>
        <div class="w-50 mx-auto">
          <div
            class="audio-progress progress-circle mb-5"
            :class="[{ 'progress-over50': played > 50 }, `progress-p${played}`]"
          >
            <div class="progress-circle-left"></div>
            <div class="progress-circle-right"></div>
            <div class="progress-circle-icon">
              <img
                src="https://resources.pzacademy.com/image/class-ui/audiolayer.png"
                width="170"
              />
            </div>
            <p class="text-center">{{ timeleft }}</p>
          </div>
          <!-- <p class="text-center">{{ timeleft }}</p> -->

          <h1 class="text-center mb-5">考前须知</h1>
          <ol>
            <li>进入答题后，您必须听完考前须知音频后才可以开始答题。</li>
            <li>音频不可以跳过，并且音频时长将会记录到整体考试时长内。</li>
            <li>
              如果在未完成播放前，您不小心关闭浏览器或退出考试重新进入，须重新开始播放。请勿关闭。
            </li>
          </ol>
        </div>
      </div>
    </div>

    <div
      class="modal-footer bg-light justify-content-between"
      v-if="exerciseType == 13 && !showAudioLayer"
    >
      <ul class="modal-footer-right list-inline">
        <li class="list-inline-item">
          <i class="pz-icon icon-clock text-secondary mr-1"></i>
          <!-- <span class="text-muted" v-if="BeforeData.isParticipated">考试剩余时间:</span> -->
          <span class="text-secondary">考试时长: {{ BeforeData.totalTime }}</span>
        </li>
      </ul>
      <ul class="modal-footer-right list-inline">
        <li class="list-inline-item">
          <span class="text-secondary">共{{ BeforeData.questionsCount }}道题</span>
        </li>
        <li class="list-inline-item">
          <button
            @click="readyGo(BeforeData.examType, BeforeData.playedVoice)"
            type="button"
            class="btn btn-primary px-4 ml-3"
          >
            开始考试
          </button>
        </li>
      </ul>
    </div>
    <!-- <div
      class="modal-footer bg-white justify-content-between"
      v-if="exerciseType == 13 && !showAudioLayer"
    >
      <div class="modal-footer-left"></div>
      <div class="modal-footer-right">
        <span class="mx-3">共{{ BeforeData.list.length }}道题</span>
        <button
          type="button"
          class="btn btn-primary btn-lg"
          @click="readyGo(BeforeData.examType, BeforeData.playedVoice)"
        >开始考试</button>
      </div>
    </div>-->
    <div class="modal-body bg-dark p-0" v-if="exerciseType == 12">
      <div
        class="text-white h-full d-flex flex-column justify-content-center text-center align-items-center"
      >
        <div class="p-5 my-5" style="max-width: 750px">
          <div class="mb-5">
            <img src="https://resources.pzacademy.com/image/class-ui/unittest.svg" width="150" />
          </div>
          <h1 class="mb-3">学科挑战</h1>
          <p class="text-secondary lead">
            参加这个挑战是完成当前课程精通级别的最佳途径，当然难度也很大，不惧挑战的您，让我们开始吧！
          </p>
          <p class="text-primary lead">
            需要达到{{ BeforeData.passRate }}的正确率，就可以让所有知识点达到皇冠级别！
          </p>
          <!-- <p class="small text-white-50">考前准备：计算器、笔、草稿纸（真实考试只能携带计算器、铅笔以及水笔，草稿纸不可携带）</p> -->
        </div>
      </div>
    </div>
    <div
      class="modal-header justify-content-between align-items-center bg-light px-2 py-1"
      v-if="exerciseType == 11"
    >
      <div class="flex-grow-1 w-0 text-truncate">
        <ul class="list-inline mb-0 d-flex align-items-center text-truncate">
          <li class="list-inline-item mx-0 pr-0 pr-md-2 border-right">
            <button type="button" class="btn btn-light text-secondary d-flex" @click="onClose">
              <i class="pz-icon icon-cancel mr-1"></i>
              <span class="d-none d-md-inline-block">关闭</span>
            </button>
          </li>
          <li class="list-inline-item ml-2 ml-md-3 text-truncate">
            <h5 class="modal-title text-truncate f-xs-14">{{ title }}</h5>
          </li>
        </ul>
      </div>

      <!-- <h5 class="modal-title text-center">{{ title }}</h5> -->

      <ul class="list-inline mb-0">
        <li class="list-inline-item mx-0 mx-lg-2">
          <button
            type="button"
            class="btn btn-light text-secondary d-flex flex-column"
            @click="onResizeModal"
          >
            <i
              class="pz-icon"
              :class="`${isFullscreen ? 'icon-fullscreen-exit' : 'icon-fullscreen'}`"
            ></i>
            <small class="d-none d-md-inline-block">全屏</small>
          </button>
        </li>
      </ul>
    </div>
    <div class="modal-body bg-dark p-0 overflow-hidden" v-if="exerciseType == 11">
      <div
        class="text-white text-center d-flex justify-content-center align-items-center flex-column h-full"
      >
        <div class="p-5">
          <h2>开始练习!</h2>
          <!-- <p>通过练习可以升级本知识点, 每答对一道题会得到10points, 答错也会相应扣掉10points</p> -->
          <p class="lead">通过练习可以升级本知识点，答对得分，答错扣分。每道题10分</p>
        </div>
        <div class="practice-overview">
          <div class="buliding-overview" :class="`_v${BeforeData.pointsReachLevel}`">
            <i class="buliding-outline-icon _lg" :class="`_b${BeforeData.pointsReachLevel}`"></i>
            <div class="buliding-group">
              <div class="_t _t4">
                <div class="buliding-line"></div>
                <div class="buliding-text">
                  <h6 class="text-white mb-0">精通 ({{ BeforeData.totalPoints }}分)</h6>
                  <!-- <small class="text-white-50">{{ BeforeData.questionsTotalCount }} of {{ BeforeData.questionsTotalCount }} correct</small> -->
                </div>
              </div>
              <div class="_t _t3">
                <div class="buliding-line"></div>
                <div class="buliding-text">
                  <h6 class="text-white mb-0">熟悉 ({{ BeforeData.layer3Points }}分)</h6>
                  <!-- <small class="text-white-50">{{ BeforeData.layer3QuestionCount }} of {{ BeforeData.questionsTotalCount }} correct</small> -->
                </div>
              </div>
              <div class="_t _t2">
                <div class="buliding-line"></div>
                <div class="buliding-text">
                  <h6 class="text-white mb-0">初步了解 ({{ BeforeData.layer2Points }}分)</h6>
                  <!-- <small class="text-white-50">{{ BeforeData.layer2QuestionCount }} of {{ BeforeData.questionsTotalCount }} correct</small> -->
                </div>
              </div>
              <div class="_t _t1">
                <div class="buliding-line"></div>
                <div class="buliding-text">
                  <h6 class="text-white mb-0">您在这里</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer bg-light justify-content-between" v-if="exerciseType == 11">
      <div class="modal-footer-left"></div>
      <div class="modal-footer-right">
        <span class="mx-3">共{{ BeforeData.questionsTotalCount }}道题</span>
        <button type="button" class="btn btn-primary px-4" @click="getPractice">开始练习</button>
      </div>
    </div>

    <div class="modal-footer bg-light justify-content-between" v-if="exerciseType == 12">
      <div class="modal-footer-left">
        <template v-if="BeforeData.haveUnSubmitChallenge && !isInReview">
          <i class="pz-icon icon-history text-secondary mr-1"></i>
          你有一个未完成的挑战 · 完成率
          {{
            BeforeData.preChallenge.correctCount + BeforeData.preChallenge.wrongCount >= 0
              ? (
                  ((BeforeData.preChallenge.correctCount + BeforeData.preChallenge.wrongCount) /
                    BeforeData.preChallenge.totalCount) *
                  100
                ).toFixed(0)
              : '0'
          }}%
          <button
            v-if="BeforeData.haveUnSubmitChallenge"
            type="button"
            class="btn btn-link"
            @click="getUnitTest(0)"
          >
            继续完成挑战
          </button>
        </template>
        <!-- <template v-if="BeforeData.haveUnSubmitChallenge">
          <i class="pz-icon icon-history text-muted mr-1"></i> 完成率:
          {{
            BeforeData.preChallenge.correctCount + BeforeData.preChallenge.wrongCount >= 0
              ? (((BeforeData.preChallenge.correctCount + BeforeData.preChallenge.wrongCount) / BeforeData.preChallenge.totalCount) * 100).toFixed(0)
              : '0'
          }}% · <timeago :datetime="BeforeData.preChallenge.startTime" locale="zh-CN"></timeago>
          <button v-if="BeforeData.haveUnSubmitChallenge" type="button" class="btn btn-link" @click="getUnitTest(0)">继续上次挑战</button>
        </template>-->
      </div>
      <div class="modal-footer-right">
        <span class="mx-3">共{{ BeforeData.totalQuestionsCount }}道题</span>

        <button type="button" class="btn btn-primary px-4" @click="getUnitTest(1)">
          {{ BeforeData.haveUnSubmitChallenge && !isInReview ? '开始新挑战' : '开始挑战'
          }}{{ isInReview ? '（回顾）' : '' }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
export default {
  name: 'Before',

  props: {
    title: String,
    isFullscreen: Boolean,
    onResizeModal: {
      type: Function,
      default: () => {},
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    exerciseType: {
      type: Number,
      default: () => '',
    },

    BeforeData: Object,

    onGetQuestions: {
      type: Function,
      default: () => {},
    },

    onStartCountingDown: {
      type: Function,
      default: () => {},
    },

    isInReview: {
      type: String,
      default: () => '',
    },

    setIsInReview: {
      type: Function,
      default: () => {},
    },
  },

  components: {},

  data() {
    return {
      showAudioLayer: false,
      timeleft: 0,
      played: 0,
    };
  },

  methods: {
    getPractice() {
      this.onGetQuestions();
    },

    getUnitTest(type) {
      if (this.isInReview) {
        this.setIsInReview({ stepInReview: 'toQuestion' });
        return;
      }
      this.onGetQuestions(type);
    },

    getMock() {
      this.onGetQuestions();
      this.onStartCountingDown();
    },

    readyGo(type, flag) {
      const _this = this;
      if (!flag) {
        _this.showAudioLayer = true;
        let player = type == 1 ? $('#player_cfa') : $('#player_frm');
        let audio = player.get(0);
        audio.play();
        player.on('ended', function () {
          _this.showAudioLayer = false;
          _this.getMock();
        });
        player.on('timeupdate', function () {
          // console.log(_this.played);
          let duration = parseInt(audio.duration),
            currentTime = parseInt(audio.currentTime),
            timeLeft = duration - currentTime,
            s,
            m;
          _this.played = Math.floor((100 * currentTime) / duration);
          s = timeLeft % 60;
          m = Math.floor(timeLeft / 60) % 60;
          s = s < 10 ? '0' + s : s;
          m = m < 10 ? '0' + m : m;
          _this.timeleft = m + ':' + s;
        });
      } else {
        _this.getMock();
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
